// extracted by mini-css-extract-plugin
export default {"icon":"CustomAddTask_icon__6wxcI"};